import React from "react";

type SizeButton = {
  isSelected?: boolean;
  text: string;
  onClick: () => void;
};

const SizeButton: React.FC<SizeButton> = ({
  isSelected = false,
  text,
  onClick,
}) => {
  return (
    <button
      // prettier-ignore
      className={`${isSelected ? "border rounded-full border-[#42463E] border-2 p-[2px] w-fit px-[12px]" : ""} h-[40px] min-w-[40px]
        ${text === "One Size" ? "text-sm leading-[12px]" : ""}
        flex  items-center justify-center`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default SizeButton;
